"use client";

import styles from "@/styles/product-detail/swiper.module.scss";
import { Swiper } from "react-vant";
import Image from "next/image";
import { PictureItem } from "@/types/product";
import { useState, useEffect } from "react";

interface Props {
  pictures: PictureItem[] | [];
}
export default function ProductSwiper({ pictures }: Props) {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const firstMagnifierImage = document.getElementById("firstMagnifierImage");
    if (firstMagnifierImage) {
      firstMagnifierImage.remove();
    }
  }, []);

  return (
    <div className={styles["comp-product-swiper"]}>
      <Swiper
        onChange={(index) => setCurrentIndex(index)}
        indicator={() => <></>}
      >
        {pictures.map((image, index: number) => (
          <Swiper.Item key={image.fileNameUrl + index}>
            <Image
              src={image.imageHDUrl || image.fileNameUrl}
              width={1000}
              height={1000}
              className={styles["swiper-image"]}
              alt={image.fileNameUrl}
            />
          </Swiper.Item>
        ))}
      </Swiper>

      <div className={styles["progress-bar-container"]}>
        <div
          className={styles["progress-bar"]}
          style={{
            width: `${((currentIndex + 1) / pictures.length) * 100}%`,
          }}
        ></div>
      </div>
    </div>
  );
}
